export default __webpack_public_path__ + "static/media/AnimalsGreen_08.6b7937f1.png";